<template>
  <div v-bind:class="[{ selected: selected }]">
    <div
      v-bind:class="{
        select: selected,
        'has-error': hasError,
        disabled: disabled,
      }"
      class="btn-payment"
      @click="selected || disabled ? false : $emit('click')"
    >
      <div class="btn-payment-content">
        <img
          width="40px"
          height="40px"
          class="w-full fit-contain"
          :src="image"
        />

        <div class="btn-payment-title">
          {{ name }}
        </div>

        <div v-if="label" class="btn-payment-desc">
          {{ label }}
        </div>

        <div
          v-if="isLessThanMinAmount"
          class="btn-payment-desc text-danger"
        >
          ยอดขั้นต่ำ
          {{ lessThanMinAmount | currency }} บาทขึ้นไป
        </div>
      </div>

      <button
        v-if="paymentPromotionTitle"
        type="button"
        :class="[
          'btn-payment-promotion',
          { 'has-html': paymentPromotionHtml },
        ]"
        @click.stop="onShowPaymentPromotion"
      >
        <div class="btn-payment-promotion-title">
          {{ paymentPromotionTitle }}
        </div>
        <v-icon size="14">
          mdi-chevron-right
        </v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'PaymentMethodItem',
  props: {
    name: String,
    label: String,
    image: String,
    selected: Boolean,
    hasError: Boolean,
    disabled: Boolean,
    lessThanMinAmount: Number,
    isLessThanMinAmount: Boolean,
    paymentPromotionTitle: String,
    paymentPromotionHtml: String,
    items: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      colorBnn,
      installmentPlan: this.items ? this.items[0] : null,
    }
  },
  methods: {
    handleChange() {
      this.$emit('updateInstallmentPlan', this.installmentPlan)
    },

    onShowPaymentPromotion() {
      if (!this.paymentPromotionTitle || !this.paymentPromotionHtml)
        return

      this.$emit('show', {
        title: this.paymentPromotionTitle,
        html: this.paymentPromotionHtml,
      })
    },
  },
  watch: {
    selected(newVal) {
      if (newVal && this.items?.length > 0) {
        this.installmentPlan = this.items[0] ?? null
        this.handleChange()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-payment
    width 100%
    height: 100%
    background white
    box-shadow: 0 0 0 1px $color-bnn-gray-light;
    border-radius: 8px
    cursor pointer
    transition: 0.2s ease-in-out
    text-align: center
    display: flex
    flex-direction: column
    justify-content: space-between
    box-sizing: border-box

    @media (hover: hover) and (pointer: fine)
        &:hover
            border-color: transparent;
            box-shadow: 0 0 0 1px $color-bnn-border;
            transition: 0.2s ease-in-out;
    .text-btn-payment
        font-size 1rem
    @media medium
        .text-btn-payment
            font-size 1.2rem
    @media small
        .text-btn-payment
            font-size 0.8rem
.btn-payment.select
    box-shadow: 0 0 0 1px $color-bnn;
    border-color: transparent;

.btn-payment.has-error
     border-color: red;
.btn-payment.disabled
	cursor: not-allowed;
	opacity: 0.5;

.btn-payment-title
    font-weight: 500
.btn-payment-desc
    font-size: 12px

.btn-payment-content
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	gap: 8px
	padding: 12px

.btn-payment-promotion
    padding: 12px

    font-size: 12px
    font-weight: 600
    line-height: 1.4
    text-align: center
    color: $color-bnn-blue
    pointer-events: fill
    border-top: 1px solid $color-bnn-gray-light

    display: inline-flex
    align-items: center
    gap: 2.5px
    text-align: left

    &.has-html&:active > .btn-payment-promotion-title
        outline: none
        text-decoration: underline

    @media (hover: hover) and (pointer: fine)
        &.has-html&:hover > .btn-payment-promotion-title
            text-decoration: underline
            transition: 0.2s ease-in-out

    > .btn-payment-promotion-title
        width: 100%;
        min-width: 0
        max-width: 100%;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

    .v-icon
        color: inherit
        flex-shrink: 0
.text-danger
	color: $color-bnn-red;
</style>
